import Box from '@mui/material/Box';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IReduxState } from '../../../store';
import { ADMIN_SERVER_BASE_URL, apiClient } from '../../../util/apiClient';
import CommonListe from '../../Common/CommonListe';
import {
    deleteGroupeFonctionnalite, IGroupeFonctionnalite,
    setGroupeFonctionnalitesBySousModule, setObjGroupeFonctionnalite,
    setOpenDialogGF,
    setValueEdit
} from './groupeFonctionnaliteSlice';




const ListeGroupeFonctionnalite = () => {


    //redux
    const dispatch = useDispatch()
    const { objModule } = useSelector((state: IReduxState) => state.module);
    const { objSousModule } = useSelector((state: IReduxState) => state.sousModule);
    const { groupeFonctionnalites, groupeFonctionnalitesBySousModule } = useSelector((state: IReduxState) => state.groupeFonctionnalite);




    const deleteItem = async (item: any) => {
        try {
            const apiPayload = { idGroupeFonctionnalite: item.idGroupeFonctionnalite }
            const res: any = await apiClient.post(ADMIN_SERVER_BASE_URL, "/route", apiPayload)
            if (res.status === 1) {
                dispatch(deleteGroupeFonctionnalite(res.data))
            } else {
                console.log("status !==1")
            }

        } catch (error) {
            console.log("🚀 ~ file: AddModule.tsx ~ line 51 ~ handleSave ~ error", error)

        }
    };


    const getGroupeFonctionnalitesBySousModule = () => {
        dispatch(setGroupeFonctionnalitesBySousModule(groupeFonctionnalites.filter((groupeFonctionnalite: IGroupeFonctionnalite) => groupeFonctionnalite.idSousModule === objSousModule.idSousModule)))
    }

    useEffect(() => {
        getGroupeFonctionnalitesBySousModule()
    }, [objSousModule, groupeFonctionnalites]);


    const handleEditDialogOpen = (item: IGroupeFonctionnalite) => {
        dispatch(setOpenDialogGF(true))
        dispatch(setObjGroupeFonctionnalite(item))
        dispatch(setValueEdit(item.libelleGroupeFonctionnalite))
    }

    return (
        <Box sx={{ width: '100%',  bgcolor: 'background.paper' }}>
            <CommonListe
                data={groupeFonctionnalitesBySousModule}
                deleteItem={deleteItem}
                setItem={setObjGroupeFonctionnalite}
                handleEditDialogOpen={handleEditDialogOpen}
            />
        </Box>
    );
}

export default ListeGroupeFonctionnalite;
